import { buildHtml, getTemplate } from '../utils/html-template';


/**
 * Builds a HTML node.
 *
 * @param  {Object} dataItem Object containing data and template
 * @return {htmlNode}
 */
function buildHtmlNode({ dataItem, template }) {
  const div = document.createElement('div');
  div.innerHTML = buildHtml(dataItem, template);

  return div;
}

/**
 * Creates a new html node for an Item
 *
 * @param  {Object} dataItem Object containing data and template
 * @return {htmlNode}
 */
function createItem({ dataItem, template }) {
  return buildHtmlNode({
    dataItem,
    template
  });
}

/**
 * Creates a new html node for a Post template
 *
 * @param  {Object} dataItem Object containing data and template
 * @return {htmlNode}
 */
function createPost({ dataItem, template }) {
  return buildHtmlNode({
    dataItem,
    template
  }).querySelector(`[data-id="${dataItem.feedTimestamp}"]`);
}

/**
 * Builds Badge HTML for the template
 *
 * @param  {Object} dataItem Object containing polled event and config
 * @return {string}
 */
export function buildBadgeHtml({ polledEvent, config }) {
  const badgeTemplate = getTemplate({
    nodeList: config.templates,
    templateName: 'badge'
  });

  if (!badgeTemplate) {
    return '';
  }

  const badgeEvent = createItem({
    dataItem: {
      badge: polledEvent.badge
    },
    template: badgeTemplate.innerHTML
  });

  return badgeEvent.innerHTML;
}

/**
 * Builds Icon HTML for the template
 *
 * @param  {Object} dataItem Object containing polled data, polled event and config
 * @return {string}
 */
export function buildIconHtml({ polledData, polledEvent, config }) {
  const iconTemplate = getTemplate({
    nodeList: config.templates,
    templateName: 'icon'
  });

  if (!iconTemplate) {
    return '';
  }

  const iconData = {
    iconsPath: polledData.iconsPath,
    type: polledEvent.type
  };
  const iconEvent = createItem({
    dataItem: iconData,
    template: iconTemplate.innerHTML
  });

  return iconEvent.innerHTML;
}

/**
 * Builds Post HTML for the template
 *
 * @param  {Object} dataItem Object containing polled event and config
 * @return {string}
 */
export function buildPostHtml({ polledEvent, config }) {
  const postEventType = 'post';
  polledEvent.id = postEventType;

  const postTemplate = getTemplate({
    nodeList: config.templates,
    templateName: postEventType
  });

  if (postTemplate === null) {
    return document.createElement('div');
  }

  return createPost({
    dataItem: polledEvent,
    template: postTemplate.innerHTML
  });
}
